// @flow
import * as React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { fontSizes, colors } from '../../../../themes';

const { minCharactersErrorMessage } = defineMessages({
  minCharactersErrorMessage: {
    id: 'global_mensaje_min',
    defaultMessage: 'Your search must be at least two characters long',
  },
});

export default function Error(): React.Node {
  return (
    <div className="wrapper">
      <span className="message">
        <FormattedMessage {...minCharactersErrorMessage} />
      </span>
      <style jsx>
        {`
          .wrapper {
            align-items: center;
            background-color: ${colors.redExtraLight};
            border: 1px solid ${colors.redLight};
            display: flex;
            justify-content: center;
            padding: 0.8em;
            margin-bottom: 1em;
            border-radius: 0.4rem;
          }
          .message {
            color: ${colors.redDark};
            font-size: ${fontSizes.mediumSmall};
            text-align: center;
          }
        `}
      </style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/Index/components/Forms/common/Error.js